export default {
  namespaced: true,
  state: () => ({
    units: [],
  }),
  mutations: {
    set (state, payload) {
      state.units = payload
    },
    add (state, payload) {
      if (state.units.length >= 3) return

      if (!state.units.includes(payload)) {
        state.units.push(payload)
      }
    },
    remove (state, payload) {
      const index = state.units.indexOf(payload)

      if (index >= 0) {
        state.units.splice(index, 1)
      }
    },
    clear (state) {
      state.units = []
    },
  },
  getters: {
    all (state, getters, rootState) {
      return rootState.unit.units.filter(unit => state.units.includes(unit.UnitNumber))
    },
    count (state) {
      return state.units.length
    },
  },
}
